exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.servicescontainer[data-v-b3d801b0] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n  position: relative;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-flow: column;\n          flex-flow: column;\n}\n@media only screen and (max-width: 450px) {\n.header[data-v-b3d801b0] {\n    font-size: 1.7rem;\n}\n}\n@media only screen and (max-width: 370px) {\n.available-products[data-v-b3d801b0] {\n    font-size: 0.85rem;\n}\n}\n@media only screen and (max-width: 350px) {\n.header[data-v-b3d801b0] {\n    font-size: 1.5rem;\n}\n.waitlist-details[data-v-b3d801b0] {\n    font-size: 12px;\n}\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b3d801b0","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/merchant/WaitingList.vue
// module id = gTAo
// module chunks = 1